// extracted by mini-css-extract-plugin
module.exports = {"rootOutline":"Button_rootOutline__Dyaqr","root":"Button_root__Afhgg"};